<template>
  <el-row style="overflow: hidden">
    <el-row class="header_div" style="overflow: hidden">
      <el-col :span="2" class="lab">
        <label class="txt">监控资源概览</label>
      </el-col>
      <el-col :span="22" class="lab_content">
        <el-row>

          <el-col :span="2">

            <i class="el-icon-omnis-linux img_icon" title="Linux "></i>
            <label class="monitor_num">{{monitor_count_info.linux_agent_count}}</label>
            <label class="monitor_all">/</label>
            <label class="monitor_all">{{monitor_count_info.linux_count}}</label>
          </el-col>
          <el-col :span="2">
            <i class="el-icon-omnis-Windows img_icon" title="Windows "></i>
            <label class="monitor_num">{{monitor_count_info.windows_agent_count}}</label>
            <label class="monitor_all">/</label>
            <label class="monitor_all">{{monitor_count_info.windows_count}}</label>
          </el-col>
          <el-col :span="2">
            <i class="el-icon-omnis-suzhujiliebiao img_icon" title="宿主机器"></i>
            <label class="monitor_num">{{monitor_count_info.physical_agent_count}}</label>
            <label class="monitor_all">/</label>
            <label class="monitor_all">{{monitor_count_info.physical_count}}</label>


          </el-col>

          <el-col :span="2">
            <i class="el-icon-omnis-wangluoshebei4 img_icon" title="网络设备"></i>
            <label class="monitor_num">{{monitor_count_info.network_device_agent_count}}</label>
            <label class="monitor_all">/</label>
            <label class="monitor_all">{{monitor_count_info.network_device_count}}</label>
          </el-col>

          <el-col :span="2">
            <i class="el-icon-omnis-server img_icon" title="存储"></i>
            <label class="monitor_num">{{monitor_count_info.storage_device_agent_count}}</label>
            <label class="monitor_all">/</label>
            <label class="monitor_all">{{monitor_count_info.storage_device_count}}</label>
          </el-col>

          <el-col :span="16">
            <div style="float: right;width: 400px;display: flex">
              <!--<el-button type="primary" size="mini" @click="reset_list_button">重置</el-button>-->
              <!--               <el-form-item label="医院" style="margin-left: 10px;" prop="project">-->

              <el-select v-if="project_conf.project_code == 'ALL'"
                         size="mini"
                         class="ops"
                         v-model="panel_search_form.project"
                         style="width: 170px" @change="project_change">

                <el-option
                  v-for="(item,index) in project_options"
                  :key="index"
                  :label="item.project_name"
                  :value="item.project_code">
                </el-option>
              </el-select>


              <el-input style="width: 250px" size="mini" class="ops" v-else v-model="panel_search_form.project_name" :disabled="true">

              </el-input>
                  <label style="font-size: 13px;margin-right: 6px">刷新</label>
              <el-select v-model="refresh_time" placeholder="刷新设置"
                         size="mini" class="ops" style="width: 80px" @change="set_refresh_time">
                <el-option label="off" value="off"></el-option>
                <el-option label="10s" value="10"></el-option>
                <el-option label="30s" value="30"></el-option>
                <el-option label="1min" value="60"></el-option>
                <el-option label="5min" value="300"></el-option>
              </el-select>

              <!--            </el-form-item>-->

            </div>

          </el-col>


        </el-row>


      </el-col>

    </el-row>
    <el-row style="padding-left: 5px">


      <el-col :span="7" class="el-table-filter" :style="panel_alarm_left_style">
        <el-row id="warning_distribute" :style="{width: '100%', height: map_height,float:'left',background:background_all,overflow:'hidden'}"></el-row>
        <el-row :style="panel_warning_left_style" class="border-top">

          <el-col :span="4" class="count_number border-right "
                  :style="{'background':warning_info['5'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['5'].number}}</div>
            <span>危险</span>
          </el-col>
          <el-col :span="4" class=" count_number border-right"
                  :style="{'background':warning_info['4'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['4'].number}}</div>
            <span>严重</span>
          </el-col>
          <el-col :span="4" class="count_number border-right"
                  :style="{'background':warning_info['3'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['3'].number}}</div>
            <span>重要</span>
          </el-col>
          <el-col :span="4" class="count_number border-right"
                  :style="{'background':warning_info['2'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['2'].number}}</div>
            <span>警告</span>
          </el-col>
          <el-col :span="4" class="count_number border-right"
                  :style="{'background':warning_info['1'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['1'].number}}</div>
            <span>提醒</span>
          </el-col>
          <el-col :span="4" class="count_number border-right"
                  :style="{'background':warning_info['-1'].color,'color':'#f0f0f0'}">
            <div class="warning_number">{{warning_info['-1'].number}}</div>
            <span>未知</span>
          </el-col>


        </el-row>


        <!--        <el-row style="text-align: center;align-items: center;margin:0 auto;">-->
        <!--          <div style="height:80px;text-align: center;align-items: center;margin:0 auto;width: 100%;display: flex">-->

        <!--            <div :span="4" class="count_box">-->
        <!--              <div class="count_number danger-color">-->
        <!--                <div>危险 {{danger_number}}</div>-->
        <!--              </div>-->

        <!--            </div>-->
        <!--            <div :span="4" class="count_box">-->
        <!--              <div class="count_number vary-important-color">-->
        <!--                严重 {{severity_number}}-->
        <!--              </div>-->
        <!--            </div>-->

        <!--            <div :span="4" class="count_box ">-->
        <!--              <div class="count_number important-color">重要 {{important_number}}</div>-->
        <!--            </div>-->

        <!--            <div :span="4" class="count_box ">-->
        <!--              <div class="count_number warning-color">警告 {{warning_number}}</div>-->
        <!--            </div>-->

        <!--            <div :span="4" class="count_box ">-->
        <!--              <div class="count_number hint-color" style="color: #82848a">提醒 {{hint_number}}</div>-->
        <!--            </div>-->


        <!--            &lt;!&ndash;           hint_number += 1&ndash;&gt;-->
        <!--            &lt;!&ndash;              } else if (data.data[i].alert_level == '2') {&ndash;&gt;-->
        <!--            &lt;!&ndash;                 += 1&ndash;&gt;-->

        <!--          </div>-->

        <!--        </el-row>-->
        <!--        <el-row>-->
        <!--          <el-col :span="8" :style="{ height: map_height}">-->
        <!--            <div id="binding" style="height:100%"></div>-->
        <!--          </el-col>-->
        <!--          <el-col :span="8" :style="{ height: map_height}">-->
        <!--            <div id="monitor_per" style="height: 100%"></div>-->
        <!--          </el-col>-->

        <!--          <el-col :span="8" :style="{ height: map_height}">-->
        <!--            <div id="type_data" style="height: 100%"></div>-->
        <!--          </el-col>-->


        <!--        </el-row>-->
        <!--        <el-row style="padding: 10px 10px 2px 10px">-->
        <!--          <div id="myChart3" :style="{width: '400x', height:map_height}"></div>-->
        <!--        </el-row>-->
        <!--        <el-row style="padding: 10px">-->
        <!--          &lt;!&ndash;        <div id="myChart4" :style="{width: '400x', height: map_height}"></div>&ndash;&gt;-->
        <!--        </el-row>-->
      </el-col>
      <el-col :span="17" class="el-table-filter">


        <el-row id="panel_warining_id">
          <el-form class="search_form" :inline="true" :model="panel_search_form" ref="panel_search_form"
                   style="margin-top: 8px;float: left;padding-left: 14px" size="mini">


            <el-form-item label="等级" prop="alert_level" size="mini">
              <sys_code_select v-model="panel_search_form.alert_level"
                               :sys_code_style='{"width":"100px"}'
                               sys_code_type="alertitem_level"
                               sys_code_placeholder="请选择预警等级"
                               :sys_code_has_all="true"
                               default_label_name="全部"
              >
              </sys_code_select>
            </el-form-item>

            <el-form-item label="状态" prop="is_confirm" size="mini">
              <sys_code_select v-model=" panel_search_form.is_confirm"
                               :sys_code_style='{"width":"100px"}'
                               sys_code_type="is_confirm"
                               :sys_code_has_all="false"
                               default_label_name="全部"
                               sys_code_placeholder="请选择预警状态"
              >
              </sys_code_select>
            </el-form-item>
            <el-form-item label="恢复" prop="is_recover">
              <sys_code_select v-model=" panel_search_form.is_recover"
                               :sys_code_style='{"width":"100px"}'
                                       sys_code_type="is_recover"
                                       sys_code_placeholder="请选择恢复状态"
                               :sys_code_has_all="false"
                               default_label_name="全部"
              >
              </sys_code_select>
            </el-form-item>
            <el-form-item label="" prop="server_search">
              <el-input size="mini" v-model="panel_search_form.server_search"
                        style="width: 300px;margin-left: 10px"
                        placeholder="资源名称、主机、编码">

                <!--              <el-button slot="append" icon="el-icon-search"></el-button>-->
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button-group>


                <!--              <el-button size="mini" type="primary" @click="search_panel_button()" icon="el-icon-search" title="搜索"></el-button>-->
                <el-button size="mini" type="primary" @click="search_panel_button()" icon="el-icon-search"
                           :title="'搜索'+time_suggest_text">
                  查询

                </el-button>
                <!--              <el-button size="mini" type="primary" @click="restart_search" icon="el-icon-refresh-left" title="重置">-->
                <!--              </el-button>-->


              </el-button-group>
            </el-form-item>
            <el-form-item style="float: right;padding-top: 5px;width: 20px" v-if="waring_table_loading"
                          class="loading_data">
                <span style=""
                      class="loading_data"

                      v-loading="waring_table_loading"
                      element-loading-spinner="el-icon-loading"

                >...</span>
            </el-form-item>

          </el-form>

        </el-row>

        <el-row :style="panel_alarm_style">

          <div class="div_card left_aside el-table-filter"
               ref="scrollContainer"
               element-loading-spinner="el-icon-loading"
               element-loading-background="#ffffffdd"
          >
            <monitoring_grafana ref="monitoring_grafana"
                                @card_click="card_click"
                                @infor_click="infor_click"
                                @confirm="confirm"
                                :zabbix_alarm_data="zabbix_alarm_tableData"></monitoring_grafana>
            <div v-if="load_more_loading" style="text-align: center; padding: 10px; color: #909399;">
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <div v-if="!has_more && zabbix_alarm_tableData.length > 0" style="text-align: center; padding: 10px; color: #C0C4CC; font-size: 12px;">
              没有更多告警了
            </div>
          </div>
        </el-row>

        <el-row align="center" style="margin-top: 5px;margin-bottom: 5px">
<!--          &lt;!&ndash;<el-col :span="4">&ndash;&gt;-->
<!--          <div style="margin-left: 10px;;width: 100px;height: 28px;margin-top: 2px;float: left"-->
<!--               align="center">-->
<!--            <span class="el-icon-omnis-xiaoxi" style="transform: translateY(3px)"></span>-->
<!--            <span style="font-size: 12px;color: black;font-weight: bolder">消息队列</span>-->
<!--          </div>-->

<!--          &lt;!&ndash;</el-col>&ndash;&gt;-->
<!--          &lt;!&ndash;<el-col :span="18">&ndash;&gt;-->
<!--          <div style="float: left;padding: 2px 10px" align="left">-->
<!--            <el-button type="primary" size="mini" @click="reset_list_button" icon="el-icon-refresh-left">全部</el-button>-->
<!--            &lt;!&ndash;<div align="left">-->
<!--    <el-button type="primary" size="mini" @click="reset_list_button">重置</el-button>&ndash;&gt;-->
<!--            &lt;!&ndash;<el-button type="primary" size="mini">历史消息</el-button>&ndash;&gt;-->
<!--            &lt;!&ndash;<el-button type="primary" size="mini">消息发送管理</el-button>&ndash;&gt;-->
<!--          </div>-->

          <div style="float: right" v-if="message_table_loading">
                     <span style=""
                           class="loading_data"

                           v-loading="message_table_loading"
                           element-loading-spinner="el-icon-loading"

                     >...</span>

          </div>
          <!--</el-col>-->
        </el-row>
        <!--消息表-->

        <!--      <el-row style="width: 100%;background-color: #6FA9C7;font-weight: bolder">-->
        <!--        <div style="padding-left: 10px;display: inline;width: 100%">-->
        <!--          <span style="font-size: 13px;display: inline">当前显示最近{{message_count }}条  今日累计发送消息：{{message_all }}  </span>-->
        <!--          <template>-->
        <!--            <span :title=message_detail-->
        <!--                  class="title"-->
        <!--                  style="cursor: pointer;font-size: 13px">-->
        <!--                         ({{ message_detail}})-->
        <!--            </span>-->
        <!--          </template>-->

        <!--        </div>-->
        <!--      </el-row>-->
      </el-col>
    </el-row>
    <el-row style="overflow: hidden;padding-left: 5px;">
      <el-col :span="10" class="el-table-filter">
        <el-row style="display: flex;padding-top: 2px;padding-bottom: 2px">

          <el-select v-model="warning_last"
                     size="mini" class="ops" style="margin-left: 10px;width: 100px"
                     @change="show_warning_type_distribute">

            <el-option label="今日告警" value="1"></el-option>
            <el-option label="7天告警" value="7"></el-option>
            <el-option label="14天告警" value="14"></el-option>

          </el-select>
          <h5 style="padding-top: 0px;padding-bottom: 0px;margin-top: 3px;margin-bottom: 2px;margin-left: 10px">
            类型触发次数分布图 、 最近七天告警统计图
          </h5>

        </el-row>
        <el-row id="warning_type_distribute"
                :style="{width: '99%', height: min_map_height}"></el-row>
        <el-row id="week_alarm" :style="{width: '99%', height:min_map_height,}"></el-row>
      </el-col>
      <el-col :span="14" class="el-table-filter" style="overflow: hidden">
        <el-row style="display: flex;padding-top: 3px">
          <h5 style="padding-top: 0px;padding-bottom: 0px;margin-top: 3px;margin-bottom: 2px;margin-left: 10px">
            主机性能分布(采样500台)
          </h5>
          <el-select v-model="last"
                     size="mini" class="ops" style="width: 150px;margin-left: 10px" @change="change_zabbix">

            <el-option label="最近3分钟" value="180"></el-option>
            <el-option label="最近5分钟" value="300"></el-option>
            <el-option label="最近30分钟" value="1800"></el-option>
            <el-option label="最近1小时" value="3600"></el-option>
          </el-select>

        </el-row>
        <el-row>

          <el-col :span="12" style="border-right:1px solid #e3e3e3">
            <el-row :style="{width: '100%', }">


              <el-row id="show_cpu"
                      v-loading="cpu_loading"
                      :style="{width: '94%', height: min_map_height,'border-bottom': '1px solid #e3e3e3','margin':'0px 3%'}">

              </el-row>
            </el-row>
            <el-row>


              <el-row id="show_disk" :style="{width: '94%', height: min_map_height,'margin':'0px 3%'}" v-loading="disk_loading">

              </el-row>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row id="show_mem"
                    v-loading="mem_loading"
                    :style="{width: '94%', height: min_map_height,'border-bottom': '1px solid #e3e3e3','margin':'0px 3%'}">

            </el-row>
            <el-row id="show_io" :style="{width: '94%', height: min_map_height,'margin':'0px 3%'}">

            </el-row>

          </el-col>
        </el-row>


      </el-col>

    </el-row>

  </el-row>
</template>

<script>
  import sys_code_select from "@/components/common_page/sys_code_select"
  import monitoring_grafana from "@/components/common_page/monitoring_grafana"
  import search_tree_select from "@/components/common_page/search_tree_select"
  import * as API from "@/api/index.js"
  import * as common from "@/common/index.js"
  import channel_type_show from "@/components/common_page/channel_type_show"

  export default {
    name: "index",
    components: {
      sys_code_select,
      monitoring_grafana,
      search_tree_select,
      channel_type_show,

    },
    data() {
      return {
        message_show: true,
        background_all: "#fafafa",
        time_suggest: {},
        project_options: [],
        map_height: (common.getTableHeight(-284) / 2) + "px",
        min_map_height: (common.getTableHeight(-222) / 4) + "px",
        panel_alarm_style: {
          "padding-left": "10px",
          height: common.getTableHeight(-238) / 2 + "px",


        },
        panel_alarm_left_style: {
          height: common.getTableHeight(-134) / 2 + "px",

        },
        panel_warning_left_style: {
          height: ((common.getTableHeight(-134) / 2) - (common.getTableHeight(-284) / 2)) - 1 + "px",//panel_alarm_left_style-map_height
          'text-align': 'center',
          'align-items': 'center',
          'margin': '0 auto',
        },
        labelPosition: 'left',
//        页面刷新下拉框的值
        refresh_time: '30',
        last: "180",
        warning_last: "7",
        //搜索框的数据
        cpu_loading:false,
        disk_loading:false,
        mem_loading:false,
        panel_search_form: {
          project: "",
          server_envs_id: '',
          server_search: '',
          alert_level: '',
          is_confirm: '0',
          is_recover: '0',
          project_name: "",
        },
        tmp_project: "",
        //各类告警级别的数量
        hint_unknown: '',
        information_number: '',
        hint_number: '',
        warning_number: '',
        important_number: '',
        severity_number: '',
        danger_number: '',
        //告警列表数据
        zabbix_alarm_tableData: [],

        //点击告警信息的告警数据
        click_warning: {},
//        消息队列的数据
        message_Data: [],
        alertitem_record_id: '',
//       页脚数据
        message_detail: '',
        message_count: '',
        message_all: '',


        border_stripe: true,
        // loading
        waring_table_loading: false,
        message_table_loading: false,
        close_qt: '0',
        cart_body_style: {padding: '6px 28px'},
        table_style: {
          height: "300px"
        },

        last_update_time: "",
        project_conf: {
          project_id: "",
          project_code: "",
          project_name: "",
        },
        warning_info: {
          "-1": {
            number: 0,
            level: "未知",
            color: "#88b0b4cf",
          },
          "0": {
            number: 0,
            level: "提醒",
            color: "#82B5D8"
          },
          "1": {
            number: 0,
            level: "提醒",
            color: "#82B5D8"
          },
          "2": {
            number: 0,
            level: "警告",
            color: "#E5AC0E",
          },
          "3": {
            number: 0,
            level: "重要",
            color: "#C05C17",
          },
          "4": {
            number: 0,
            level: "严重",
            color: "#BF1B00",
          },
          "5": {
            number: 0,
            level: "危险",
            color: "#890F02",
          }
        },

        monitor_count_info: {
          "storage_device_agent_count": 0,
          "storage_device_count": 0,
          "network_device_agent_count": 0,
          "network_device_count": 0,
          "linux_agent_count": 0,
          "linux_count": 0,
          "windows_agent_count": 0,
          "windows_count": 0,
          "physical_agent_count": 0,
          "physical_count": 0,
        },
        page: 1,
        size: 20,
        has_more: true,
        load_more_loading: false,
      }
    },
    mounted() {
      // this.table_height.height =  common.getTableHeight(-500) + "px"
      // this.$nextTick(() => {
      //   this.table_style.height = "255px"
      //   this.panel_alarm_style.height = common.getTableHeight(-218) / 2 + "px"
      //   this.panel_alarm_left_style.height = common.getTableHeight(-114) / 2 + "px"
      // })


      // this.get_agent_binding()
      this.$echarts =  require('echarts')
      this.search_panel_button()
      this.get_week_alarm()
      this.show_warning_type_distribute()
      this.getProjectsData()
      this.show_cpu()
      this.show_mem()
      this.show_disk()
      this.show_io()
      this.monitor_count()



      // this.information_list_getData()
      // this.detail_number_getData()
      // this.getProjectsData()
      // this.get_suggest_time()
      // this.type_data()
      // this.get_week_alarm()
      // this.monitor_proportion()
      // this.most_alarm_server()
      this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer;
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', this.handle_scroll);
        }
      });
    },
    beforeDestroy() {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handle_scroll);
      }
    },
    computed: {
      time_suggest_text() {
        let time_sugget = this.get_time_suggest()
        if (time_sugget) {
          return "前" + time_sugget["time"] + time_sugget["unit"]
        } else {
          return ""
        }

      }
    },

    methods: {
      change_zabbix() {
        this.show_cpu()
        this.show_mem()
        this.show_disk()
        this.show_io()
      },
      get_color() {
        let color = []
        for (let key in this.warning_info) {
          let item = this.warning_info[key]
          if (item.number > 0) {
            color.push(item.color)
          }

        }
        return color
      },
      get_number() {
        let data = []
        for (let key in this.warning_info) {
          let item = this.warning_info[key]
          if (item.number > 0) {
            data.push({value: item.number, name: item.level},)
          }


        }
        return data
      },

      async show_cpu() {

        let form = {"last": this.last, "item_name": "CPU Total", "project": this.panel_search_form.project}
        this.cpu_loading = true
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/zabbix_count", form)
        this.cpu_loading = false
        let result = response.data.data
        let y_data = []
        let show_data = []
        let result_dict = {}
        for (let i = 0; i < result.length; i++) {
          let item = result[i]
          let name = `${item["min"]}-${item["max"]}%`
          y_data.push(name)
          show_data.push({value: item["server_count"], name: name})
          result_dict[i] = item
        }
        let _this = this

        let option = {
          tooltip: {
            trigger: 'item',

            formatter: function (params) {

              let data_index = params.dataIndex
              let data = result_dict[data_index]
              let name = `${data["min"]}-${data["max"]}%`
              let text = `CPU利用率： ${name} <br> 服务器数量: ${data.server_count}<br>比例： ${params.percent}%`

              return text
            }
          },
          title: {
            subtext: 'CPU性能分布',

            left: 'left'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            data: y_data
          },
          series: [
            {
              name: 'CPU 主机利用率',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },

              itemStyle: {
                normal: {

                  color: function (params) {


                    return _this.warning_info[(params.dataIndex + 1) + ""].color

                  },
                }
              },
              data: show_data
            }
          ]
        };

        let warning_distribute = this.$echarts.init(document.getElementById('show_cpu'))
        warning_distribute.setOption(option)

      },

      async show_mem() {
        let form = {"last": this.last, "item_name": "MemUsed(Perc),Mem Used", "project": this.panel_search_form.project}
        this.mem_loading = true
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/zabbix_count", form)
        this.mem_loading = false
        let result = response.data.data
        let y_data = []
        let show_data = []
        let result_dict = {}
        for (let i = 0; i < result.length; i++) {
          let item = result[i]
          let name = `${item["min"]}-${item["max"]}%`
          y_data.push(name)
          show_data.push({value: item["server_count"], name: name})
          result_dict[i] = item
        }
        let _this = this

        let option = {
          tooltip: {
            trigger: 'item',


            formatter: function (params) {

              let data_index = params.dataIndex
              let data = result_dict[data_index]
              let name = `${data["min"]}-${data["max"]}%`
              let text = `内存利用率： ${name} <br> 服务器数量: ${data.server_count} <br>比例： ${params.percent}%`

              return text
            }

          },
          title: {
            subtext: '应用内存使用率',

            left: 'left'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            data: y_data
          },
          series: [
            {
              name: 'CPU 主机利用率',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },

              itemStyle: {
                normal: {

                  color: function (params) {


                    return _this.warning_info[(params.dataIndex + 1) + ""].color

                  },
                }
              },
              data: show_data
            }
          ]
        };

        let warning_distribute = this.$echarts.init(document.getElementById('show_mem'))
        warning_distribute.setOption(option)

      },
      async show_disk() {

        let form = {
          "last": this.last,
          "item_name": "Free disk space on $1 (percentage)",
          "project": this.panel_search_form.project
        }
        this.disk_loading = true
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/zabbix_disk_use_count", form)
        this.disk_loading = false
        let result = response.data.data
        let y_data = []
        let show_data = []
        let result_dict = {}
        for (let i = 0; i < result.length; i++) {
          let item = result[i]
          let name = `${item["min"]}-${item["max"]}%`
          y_data.push(name)
          show_data.push({value: item["server_count"], name: name})
          result_dict[i] = item
        }
        let _this = this

        let option = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {

              let data_index = params.dataIndex
              let data = result_dict[data_index]
              let name = `${data["min"]}-${data["max"]}%`
              let text = `内存利用率： ${name} <br> 服务器数量: ${data.server_count} <br>比例： ${params.percent}%`

              return text
            }
          },
          title: {
            subtext: '磁盘空间利用率',

            left: 'left'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            data: y_data
          },
          series: [
            {
              name: '磁盘空间利用率',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },

              itemStyle: {
                normal: {

                  color: function (params) {


                    return _this.warning_info[(params.dataIndex + 1) + ""].color

                  },
                }
              },
              data: show_data
            }
          ]
        };

        let warning_distribute = this.$echarts.init(document.getElementById('show_disk'))
        warning_distribute.setOption(option)

      },
     async show_io() {

        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/probe_proportion", form)
        let result = response.data.data
        let data = [{"name": '绑定', value: result.monitor_agent_count}, {
          name: "未绑定",
          value: (result.server_count - result.monitor_agent_count)
        }]
        let legend_data = ["绑定", "未绑定"]

        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          title: {
            subtext: '监控覆盖率',

            left: 'left'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            data:legend_data
          },
           color: ["#6FA9C7", "#334B5C"],
          series: [
            {
              name: '监控覆盖率',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },

              // itemStyle: {
              //   normal: {
              //
              //     color: function (params) {
              //
              //       // build a color map as your need.
              //
              //       var colorList = [
              //
              //
              //         '#FE8463', '#9BCA63', '#FAD860',
              //
              //         '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0'
              //
              //       ];
              //
              //       return colorList[params.dataIndex]
              //
              //     },
              //   }
              // },
              data: data
            }
          ]
        };

        let warning_distribute = this.$echarts.init(document.getElementById('show_io'))
        warning_distribute.setOption(option)

      },


      async show_warning_type_distribute() {

        let form = {"project": this.panel_search_form.project, "warning_last": this.warning_last}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/monitor_alert_type_count", form)
        let result = response.data.data
        let y_data = []
        let show_data = []
        let result_dict = {}
        for (let i = 0; i < result.length; i++) {
          let item = result[i]
          y_data.push(item["alertitem_code"])
          show_data.push(item["alert_count"])
          result_dict[i] = item
        }
        let _this = this


        let option = {

          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let data_index = params[0].dataIndex
              let data = result_dict[data_index]
              let alert_level = result_dict[data_index].alert_level
              let important = "未知"
              if (_this.warning_info[alert_level]) {
                important = _this.warning_info[alert_level].level
              }
              let text = `${data.alert_msg} <br> 告警次数: ${data.alert_count}<br> 等级:${important}`

              return text

            },
            axisPointer: {
              type: 'shadow'
            }
          },

          grid: {
            top: '0%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',

          },
          yAxis: {
            type: 'category',
            data: y_data
          },
          series: [
            {
              name: "",
              type: 'bar',


              barWidth: '100%',
              //图形形状
              itemStyle: {
                normal: {

                  color: function (params) {

                    // build a color map as your need.


                    let alert_level = result_dict[params.dataIndex].alert_level
                    if (_this.warning_info[alert_level]) {
                      return _this.warning_info[alert_level].color
                    } else {
                      return _this.warning_info["-1"].color
                    }


                  },
                }
              },

              data: show_data
            },

          ]
        };
        let warning_distribute = this.$echarts.init(document.getElementById('warning_type_distribute'))
        warning_distribute.setOption(option)

      },

      show_warning_distribute() {

        let option = {

          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          color: this.get_color(),
          series: [
            {
              name: ['告警类型'],
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: true,
                // position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true
              },
              data: this.get_number(),


            }
          ]
        };
        let warning_distribute = this.$echarts.init(document.getElementById('warning_distribute'))
        warning_distribute.setOption(option)


      },
      project_change() {


        // this.type_data()
        this.search_panel_button()
        this.monitor_count()
        // this.monitor_proportion()
        // this.get_agent_binding()
        // this.get_week_alarm()
        this.monitor_alert_type_count()
        this.show_warning_type_distribute()
        this.change_zabbix()
        // this.most_alarm_server()
        // this.information_list_getData()

      },
      async get_week_alarm() {

        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/get_week_alarm", form)

        let result = response.data.data
        let data = []
        let names = []

        let cols = []
        let all = result.all

        for (let i = 0; i < all.length; i++) {
          let item = all[i]
          data.push(item.count)
          names.push(item.hostip)
          cols.push(item.day)
        }
        let all_data = {
          name: '告警总数',
          type: 'line',
          data: data
        }

        var danger_count_data = []
        for (let i = 0; i < result.danger_count.length; i++) {
          let item = result.danger_count[i]
          danger_count_data.push(item.count)
        }

        var important_count_data = []
        var data_col = []
        for (let i = 0; i < result.important_count.length; i++) {
          let item = result.important_count[i]
          important_count_data.push(item.count)
        }

        let important_data = {
          name: '重要总数',
          type: 'line',
          data: important_count_data
        }


        let danger_data = {
          name: '危险总数',
          type: 'line',
          data: danger_count_data
        }
        var serious_count_data = []
        for (let i = 0; i < result.serious_count.length; i++) {
          let item = result.serious_count[i]
          serious_count_data.push(item.count)
        }
        let serious_data = {
          name: '严重总数',
          type: 'line',
          data: serious_count_data
        }
        data_col.push(all_data.name)
        data_col.push(danger_data.name)
        data_col.push(important_data.name)
        data_col.push(serious_data.name)
        let weekAlarm = this.$echarts.init(document.getElementById('week_alarm'))

        let option3 = {
          tooltip: {
            trigger: 'axis',

          },
          grid: {
            top: '6%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },

          title: {
            // text: '最近7天告警数',
            // x: 'center',
            // textStyle: {
            //   fontSize: 14,
            //   fontFamily: 'sans-serif',
            // }
          },
          legend: {
            bottom: 0,
            top: 0,
            data: data_col
          },
          xAxis: {
            type: 'category',
            data: cols
          },
          yAxis: {
            type: 'value'
          },
          series: [
            all_data,
            danger_data,
            important_data,
            serious_data
          ]
        };

        weekAlarm.setOption(option3)
      },

      async most_alarm_server() {
        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/get_most_alarm_server", form)
        let result = response.data.data
        let data = []
        let names = []

        let cols = []

        let dict = {}
        for (let i = 0; i < result.length; i++) {
          let item = result[i]
          data.push(item.count)
          cols.push(item.hostip)
          dict[item.hostip] = item.server_busi_name
          // cols.push(i + 1)
        }

//         let myChart4 = this.$echarts.init(document.getElementById('myChart4'))
//         let option4 = {
//           title: {
//             text: '告警最多主机(显示' + this.time_suggest_text + '数据)',
//             x: 'center',
//             textStyle: {
//               fontSize: 13,
//               fontFamily: 'sans-serif',
//             }
//           },
//           tooltip: {
//             trigger: 'axis',
//             axisPointer: {            // 坐标轴指示器，坐标轴触发有效
//               type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
//             },
//              formatter: function (params) {
//                 var tar = params[0];
//                 let server_busi_name = dict[tar.axisValue]
//                 if(!server_busi_name ){
//                   server_busi_name = ""
//                 }
//                 return tar.name+" "+server_busi_name + '<br/> 告警数'  + ' : ' + tar.value;
//             }
//           },
//           grid: {
//             top: '18%',
//             bottom: '25%',
//           },
// //          legend: {
// //             data:cols,
// //
// // },
//           xAxis: {
//             type: 'category',
//             data: cols,
//             axisLabel: {
//               interval: 0,
//               rotate: 20,
//             },
//           },
//           yAxis: {
//             type: 'value'
//           },
//           series: [{
//             data: data,
//             type: 'bar',
//             itemStyle: {
//               normal: {
//
//                 color:  function(params) {
//
//                             // build a color map as your need.
//
//                             var colorList = [
//
//                               '#C05C17','#B5C334','#FCCE10','#E87C25','#27727B',
//
//                                '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
//
//                                '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
//
//                             ];
//
//                             return colorList[params.dataIndex]
//
//                 },
//               }
//             },
//           }]
//         };
//         myChart4.setOption(option4)
      },

      async type_data() {
        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/type_warn_data/type_warn_data", form)
        let result = response.data.data
        let type_data = this.$echarts.init(document.getElementById('type_data'))
        let data = []
        let color = []
        let cols = []
        let sum = 0
        result.map(item => {
          sum += item.count
          data.push({name: item['level_name'], value: item.count})
          cols.push(item['level_name'])
          let level = item["alert_level"]
          switch (level) {
            case '1':
              color.push("#82B5D8")
              break;
            case '2':

              color.push("#E5AC0E")
              break;

            case '3':

              color.push("#C05C17")
              break;

            case '4':
              color.push("#BF1B00")
              break;

            case '5':
              color.push("#890F02")
              break;
            default:
              color.push("#EDF7F0")

          }
        })

        if (data.length == 0) {
          let name = "无告警"
          data.push({name: name, value: 0})
          cols.push(name)
          color.push("#82B5D8")
          sum += 0.01
        }

        // let data = [{"name": '已监控', value: result.count_monitor}, {
        //   name: "未监控",
        //   value: (result.count_solution - result.count_monitor)
        // }]
        // 绘制图表
        type_data.setOption({
          title: {
            text: '告警占比\n(显示' + this.time_suggest_text + '数据)',
            x: 'center',
            textStyle: {
              fontSize: 13,
              fontFamily: 'sans-serif',
            }
          },
          tooltip: {
            trigger: 'item',

          },
          grid: {
            top: '18%',
            bottom: '12%',
          },
          color: color,
          legend: {
            type: 'scroll',
            x: 'center',
            y: 'bottom',
            data: cols,
          },
          series: [
            {
              name: '告警级别',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: data,
              label: {
                normal: {
                  show: true,
                  position: 'inner',
                  textStyle: {
                    fontWeight: 100,
                    fontSize: 13    //文字的字体大小
                  },
                  formatter: (a) => {
                    //提前计算好sum，代表所有数值的和

                    let value = (a.value * 100 / sum).toFixed(0)
                    if (value < 10 && sum != 0.01) {
                      return ""
                    } else if (value == 0) {
                      return "0%"
                    } else {
                      return value + "%"
                    }
                  }
                },
                emphasis: {
                  show: false
                }
              },
            }
          ]
        });
      },
      async monitor_count() {
        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/monitor_count_info", form)
        let result = response.data.data
        this.monitor_count_info = result
      },
      async monitor_alert_type_count() {

      },
      async monitor_proportion() {
        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/monitor_proportion", form)
        let result = response.data.data
        let myChart2 = this.$echarts.init(document.getElementById('monitor_per'))
        let legend_data = []
        let data = []
        result.count_solution = 0

        result.map(item => {
          let code = item.alertitem_code
          legend_data.push(code)
          data.push({value: item.count, name: code})
          result.count_solution += item.count

        })

        if (data.length == 0) {
          let code = "无告警"
          legend_data.push(code)
          data.push({value: 0, name: code})
          result.count_solution += 0.01
        }


        // 绘制图表
        myChart2.setOption({
          title: {
            text: '监控指标占比\n(显示' + this.time_suggest_text + '数据)',
            x: 'center',
            textStyle: {
              fontSize: 13,
              fontFamily: 'sans-serif',
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          grid: {
            top: '18%',
            bottom: '12%',
          },
          color: ["#A8C023", "#6FA9C7", "#334B5C", "#E5AC0E", "#82B5D8"],
          legend: {

            type: 'scroll',
            data: legend_data,
            x: 'center',
            y: 'bottom',
          },
          series: [
            {
              name: '告警编码',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: data,
              label: {
                normal: {
                  show: true,
                  position: 'inner',
                  textStyle: {
                    fontWeight: 100,
                    fontSize: 11    //文字的字体大小
                  },
                  formatter: (a) => {

                    let sum = result.count_solution
                    let value = (a.value * 100 / sum).toFixed(0)
                    if (value < 10 && sum != 0.01) {
                      return ""
                    } else if (value == 0) {//处理没有数据情况
                      return "0%"
                    } else {
                      return value + "%"
                    }

                  }
                },
                emphasis: {
                  show: false
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },

            }
          ]
        });
      },

      async get_agent_binding() {
        let form = {"project": this.panel_search_form.project}
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/monitor_count/probe_proportion", form)
        let result = response.data.data
        let data = [{"name": '绑定', value: result.monitor_agent_count}, {
          name: "未绑定",
          value: (result.server_count - result.monitor_agent_count)
        }]
        let legend_data = ["绑定", "未绑定"]

        // 绘制图表
        let myChart = this.$echarts.init(document.getElementById('binding'))
        myChart.setOption({
          grid: {
            left: "0%",

            top: '18%',
            bottom: '12%',
          },
          title: {
            text: '监控覆盖率',
            x: 'center',
            textStyle: {
              fontFamily: 'sans-serif',
              fontSize: 13
            }
          },
          color: ["#6FA9C7", "#334B5C"],
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          center: ['10%', '10%'],
          legend: {
            type: 'scroll',

            x: 'center',
            y: 'bottom',
            data: legend_data,

          },
          series: [
            {

              name: '主机',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: data,
              label: {
                normal: {
                  show: true,
                  position: 'inner',
                  textStyle: {
                    fontWeight: 100,
                    fontSize: 13    //文字的字体大小
                  },
                  formatter: (a) => {
                    //提前计算好sum，代表所有数值的和
                    return (a.value * 100 / result.server_count).toFixed(0) + "%"
                  }
                },
                emphasis: {
                  show: false
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
            }
          ]
        });
      },
      get_time_suggest() {
        return this.time_suggest[this.panel_search_form.is_recover]
      },
      addDays(date, value) {
        date.setDate(date.getDate() + value);
      },
      addMins(date, value) {
        date.setMinutes(date.getMinutes() + value);
      },
      async get_suggest_time() {
        const response = await API.GET("/omnis/monitoring_center/monitoring_real_time/time_suggest/time_suggest")
        let data = response.data
        if (data.success) {
          this.time_suggest = data.data
        }
      },
      async getProjectsData() {
        this.channel_loading = true
        const response = await API.GET("/omnis/message_center/message_passage/get_sys_projects")
        this.channel_loading = false
        let data = response.data
        if (data.success) {
          this.project_options = data.data
          this.project_options.map(item => {
            if (item.zabbix_default_project == 'true') {
              this.panel_search_form.project = item.project_code
              this.tmp_project = item.project_code
              this.panel_search_form.project_name = item.project_name
              this.project_conf.project_id = item.sys_project_id
              this.project_conf.project_code = item.project_code
              this.project_conf.project_name = item.project_name
            }
          })
        }

      },
      genData(count) {
        var nameList = [
          '赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'
        ];
        var legendData = [];
        var seriesData = [];
        var selected = {};
        for (var i = 0; i < 50; i++) {
          var name = Math.random() > 0.65
            ? makeWord(4, 1) + '·' + makeWord(3, 0)
            : makeWord(2, 1);
          legendData.push(name);
          seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
          });
          selected[name] = i < 6;
        }

        return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
        };

        function makeWord(max, min) {
          var nameLen = Math.ceil(Math.random() * max + min);
          var name = [];
          for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
          }
          return name.join('');
        }
      },
      getTableHeight() {
        // return (window.screen.height - 335) / 2 + 'px'
      },


      //重置查询条件
      restart_search() {
        this.resetForm('panel_search_form')
        if (this.$refs.search_tree_select) {
          this.$refs.search_tree_select.clearSelectedNodes()
        }
        this.panel_search_form.project = this.tmp_project


        this.search_panel_button()
        this.$nextTick(() => {
          this.type_data()
        })
      },

      //获取告警统计数据
      async warning_panel_getStats() {
        var datas = JSON.parse(JSON.stringify(this.panel_search_form))
        let time_suggest = this.get_time_suggest()
        let alert_time = ""
        if (time_suggest) {
          alert_time = new Date()
          if (time_suggest["unit"] == "天") {
            this.addDays(alert_time, parseInt(time_suggest["time"]) * -1)
          } else {
            this.addMins(alert_time, parseInt(time_suggest["time"]) * -1)
          }
        }
        if (alert_time) {
          datas["alert_time"] = alert_time.Format("yyyy-MM-dd hh:mm:ss")
        }
        
        try {
          const response = await API.GET('/omnis/monitoring_center/monitoring_real_time/monitor_realtime_stats', datas)
          if (response && response.data && response.data.success) {
            const stats = response.data.data.stats
            // 重置统计数据
            for (let key in this.warning_info) {
              this.warning_info[key].number = 0
            }
            // 填充最新统计
            for (let key in stats) {
              if (this.warning_info[key]) {
                this.warning_info[key].number = stats[key]
              } else if (key === '-1') {
                this.warning_info["-1"].number = stats[key]
              }
            }
            this.show_warning_distribute()
          }
        } catch (error) {
          console.error("Fetch stats error:", error)
        }
      },

      //获取告警列表数据
      async warning_panel_getData(isLoadMore = false) {
        if (!isLoadMore) {
          this.page = 1
          this.has_more = true
          this.waring_table_loading = true
          this.warning_panel_getStats() // 初次搜索时同步更新统计
        } else {
          if (!this.has_more || this.load_more_loading) return
          this.load_more_loading = true
        }

        var datas = JSON.parse(JSON.stringify(this.panel_search_form))
        let time_suggest = this.get_time_suggest()
        let alert_time = ""
        if (time_suggest) {
          alert_time = new Date()
          if (time_suggest["unit"] == "天") {
            this.addDays(alert_time, parseInt(time_suggest["time"]) * -1)
          } else {
            this.addMins(alert_time, parseInt(time_suggest["time"]) * -1)
          }
        }

        datas.page = this.page.toString()
        datas.size = this.size.toString()

        if (alert_time) {
          datas["alert_time"] = alert_time.Format("yyyy-MM-dd hh:mm:ss")
        }
        
        try {
          const response = await API.GET('/omnis/monitoring_center/monitoring_real_time/monitor_realtime', datas)
          this.last_update_time = new Date().Format("yyyy-MM-dd hh:mm:ss")
          
          if (isLoadMore) {
            this.load_more_loading = false
          } else {
            this.waring_table_loading = false
          }

          if (response && response.data) {
            var data = response.data
            if (data.success) {
              if (isLoadMore) {
                this.zabbix_alarm_tableData = this.zabbix_alarm_tableData.concat(data.data)
              } else {
                this.zabbix_alarm_tableData = data.data
              }
              
              if (data.data.length < this.size) {
                this.has_more = false
              } else {
                this.page++
              }
            } else {
              this.$message.error(data.msg);
            }
          }
        } catch (error) {
          if (isLoadMore) this.load_more_loading = false
          else this.waring_table_loading = false
          console.error("Fetch data error:", error)
        }
      },

      //获取消息队列数据
      async information_list_getData() {
        this.message_table_loading = true
        var datas = {'alertitem_record_id': this.alertitem_record_id, "project": this.panel_search_form.project}
        const response = await API.GET('/omnis/monitoring_center/monitoring_real_time/message_log', datas)
        this.message_table_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.message_Data = data.data
            this.message_count = data.count
            //       this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        } else {
          // this.$message.error('系统错误');
        }
      },

      //获取消息队列页脚数据
      async detail_number_getData() {
        const response = await API.GET('/omnis/monitoring_center/monitoring_real_time/get_msg_count')
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.message_all = data.count
            var show_foot = ''
            data.data.sort(this.compare("msg_count"))
            for (var i = 0; i < data.data.length && i < 3; i++) {

              show_foot += data.data[i].code_name + ' : ' + data.data[i].msg_count + ' ; '
            }
            this.message_detail = show_foot
          } else {
            this.$message.error(data.msg);
          }
        } else {
          // this.$message.error('系统错误');
        }
      },
      compare(attr) {
        return function (a, b) {
          var value1 = a[attr];
          var value2 = b[attr];
          return value2 - value1;
        }
      },

      msg_content_show(content, number) {
        var content_text = ''
        if (content == '' || content == undefined) {

        } else {
          if (content.length > number) {
            content_text = content.substring(0, number) + '....'
          } else {
            content_text = content
          }
        }
        return content_text
      },

      //区域选择列表的点击事件
      area_change(data) {
        this.panel_search_form.server_envs_id = data.join(",")
      },
      search_panel_button() {
        this.warning_panel_getData(false)
      },

      resetForm(formName) {
        if (this.$refs[formName] != undefined) {
          this.$refs[formName].resetFields();
        }
      },

      //告警列表的点击事件
      card_click(item) {
        this.click_warning = item

      },
      confirm() {
        this.warning_panel_getData(false)
      },
      infor_click(item) {
        this.click_warning = item
        this.alertitem_record_id = item.alertitem_record_id
        this.information_list_getData()
      },

      reset_list_button() {
        this.alertitem_record_id = ''
        this.information_list_getData()
      },

      //刷新时间设置
      set_refresh_time() {
        //通过$once来监听定时器，在beforeDestroy钩子可以被清除。
        clearInterval(window.$timer);
        let time = 0
        if (this.refresh_time == 'off') {
          clearInterval(window.$timer);
        } else {
          this.timing_refresh(parseInt(this.refresh_time) * 1000)
        }
        this.$message.success('刷新时间设置成功');
      },
      //定时刷新
      timing_refresh(refresh_time) {
        const timer = setInterval(() => {
          this.warning_panel_getData(false) // 定时刷新第一页和统计
          this.information_list_getData()
        }, refresh_time);
        window.$timer = timer
      },

      //滚动加载
      handle_scroll(e) {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        // 距离底部50px时触发加载
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          if (this.has_more && !this.load_more_loading && !this.waring_table_loading) {
            this.warning_panel_getData(true);
          }
        }
      },
    }
  }
</script>

<style scoped>
  .el-form-item {
    margin-bottom: 3px;
  }

  .divcss5 {
    text-align: left;
    /*height: 20px;*/
  }

  .text {
    font-size: 13px;
    color: white;
  }

  .div_card {
    overflow: auto;
    padding: 4px;
    height: 100%;
    border: 1px solid #DDE4ED;
    font-family: Roboto, Helvetica Neue, Arial, sans-serif;
    color: #52545c;
    background-color: #fff;
    border: 1px solid #dde4ed;
    position: relative;
    border-radius: 3px;
  }

  .box-card {
    width: 98%;
    margin: 5px auto;

    background: #29292B;
    /*border: none;*/
  }

  .loading_data .el-loading-spinner i {
    color: #409EFF;
    margin-top: 16px !important;
  }

  .title {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    display: inline-block;
    transform: translateY(2px) !important;
  }

  .title_table {
    max-width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    display: inline-block;
    transform: translateY(2px) !important;
  }

  .count_number {

    padding-top: 3px;
    text-align: center;
    color: #5c5c5c;
    /*font-weight: bold;*/
    border: 1px solid #dde4ed;
    position: relative;
    border-radius: 0px;


  }

  .warning_number {
    font-size: x-large;
    font-weight: bolder
  }

  .count_box {
    padding: 10px;
    width: 17%;
    float: left;
  }

  .danger-color {
    background-color: rgb(137, 15, 2);
  }

  .vary-important-color {

    background-color: rgb(191, 27, 0)
  }

  .important-color {
    background-color: rgb(192, 92, 23);
  }

  .warning-color {
    background-color: rgb(229, 172, 14);
  }

  .hint-color {
    background-color: rgb(130, 181, 216);
  }

  .header_div {
    border: 1px solid #e3e3e3;
    border-radius: 3px;
    height: 50px;
    line-height: 50px;
    margin-left: 5px;
    margin-right: 2px;
    margin-top: 5px;


  }

  .header_div .lab {
    padding-left: 10px;
    border-right: 1px solid #e3e3e3;
    text-align: center;
    background: #F0F1F5;
  }

  .header_div .lab_content {
    padding-left: 50px;

    background: #FAFBFD;
  }

  .header_div .lab_content .img_icon {
    font-size: 32px;
    transform: translateY(6px);
    color: #A3C5EB;
  }

  .header_div .lab_content .monitor_num {
    color: #bd2c00
  }

  .header_div .lab_content .monitor_all {
    color: #4c4c4c
  }

  .header_div .lab .txt {
    font-family: '宋体';
    font-weight: bold;
    color: #444444;

  }

  .border-top {
    border-top: 1px solid #e3e3e3;
  }

  .border-right {
    height: 100%;
    border-right: none;
  }


</style>




// WEBPACK FOOTER //
// index.vue?45abe52b